// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'letter';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M16.313 6.188H1.688c-.622 0-1.125.503-1.125 1.125v9c0 .62.503 1.125 1.125 1.125h14.624c.622 0 1.125-.504 1.125-1.125v-9c0-.622-.503-1.125-1.125-1.125zM1.875 3.375h14.25M3.375.563h11.25M3.375 12.188h2.813m-2.813 2.625h6.188' />
    <path d='M14.25 8.813H12a.562.562 0 0 0-.563.562v2.25c0 .31.252.563.563.563h2.25c.31 0 .563-.252.563-.563v-2.25a.562.562 0 0 0-.563-.563z' />
  </g>
);

export const viewBox = '0 0 18 18';
